import 'styles/app.css';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigProvider } from 'antd/es';
import { CookiesProvider } from 'react-cookie';
import { Provider as ReduxProvider } from 'react-redux';

import { isRunningInsideCypress } from 'utils/test-utils';

import { AppRouter } from 'containers/AppRouter';
import { AuthProvider } from 'contexts/AuthProvider';
import { NotificationProvider } from 'contexts/NotificationProvider';

import { setupStore } from 'reduxLocal/store';

import { getAxiosInstance } from 'api/utils';

import { ANTD_THEME } from './antdThemeConfig';
import { CustomerApiAuthInterceptor } from './CustomerApiAuthInterceptor';

const store = setupStore();

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      // Adds retry to mutations to account for potential refresh token
      retry: 1
    }
  }
});

export const App = () => {
  if (isRunningInsideCypress()) {
    // @ts-expect-error: expose the store for cypress
    window.__reduxStore__ = store;
    // @ts-expect-error: expose the store for cypress
    window.__axiosInstance__ = getAxiosInstance();
  }

  return (
    <ConfigProvider theme={ANTD_THEME}>
      <CookiesProvider>
        <ReduxProvider store={store}>
          <AuthProvider>
            <NotificationProvider>
              <QueryClientProvider client={queryClient}>
                <CustomerApiAuthInterceptor>
                  <AppRouter />
                </CustomerApiAuthInterceptor>
              </QueryClientProvider>
            </NotificationProvider>
          </AuthProvider>
        </ReduxProvider>
      </CookiesProvider>
    </ConfigProvider>
  );
};
